import requestGetCall from "../requestCall";
import { OFFERING_URL } from "../apiConstants";

const getOfferingDetails = async () => {
  const baseData = {
    endPoint: OFFERING_URL,
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };

  return requestGetCall(baseData);
};

export default getOfferingDetails;
